module.exports = __webpack_public_path__ + "static/img/zhuanxiang.2fbfb66a.svg";